import React from 'react';
import { Link } from 'react-router-dom';


const Footer = () => {
  return (
    <div>
      {/***********************************
      Footer start************************************/}
      <div className="footer">
        <div className="copyright">
          <p>
            Copyright © Developed by{" "}
            <Link to="#" target="_blank">
              OVA-consulting
            </Link>{" "}
            2024
          </p>
        </div>
      </div>
      {/***********************************
      Footer end************************************/}
    </div>
  )
}

export default Footer;
